import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebook, 
  FaLinkedin,
  FaWhatsapp,
  FaClock,
  FaRocket
} from 'react-icons/fa';
import '../styles/Contact.css';

const Contact = () => {
  return (
    <div className="contact-page-wrapper">
      {/* Hero Section */}
      <section className="contact-hero bg-gradient-primary py-5">
        <Container>
          <Row className="justify-content-center text-center text-white">
            <Col lg={8}>
              <Badge bg="success" className="mb-3 px-3 py-2 rounded-pill">
                🌱 AGRICULTEUR AVISÉ
              </Badge>
              <h1 className="display-5 fw-bold mb-3">
                Votre <span className="text-warning">exploitation</span> mérite 
                <span className="text-warning"> LA SOLUTION GAGNANTE</span>
              </h1>
              <p className="lead mb-4 opacity-90">
                Vous investissez avec sagesse dans votre terre ? GUIRETTE transforme votre vision agricole 
                en <strong>résultats concrets et rentables</strong>. Rejoignez les agriculteurs qui ont choisi l'excellence.
              </p>
              <div className="d-flex flex-wrap justify-content-center gap-2 mt-4">
                <Badge bg="warning" text="dark" className="px-3 py-2">
                  🚜 Augmentation rendement
                </Badge>
                <Badge bg="warning" text="dark" className="px-3 py-2">
                  💰 Optimisation investissement
                </Badge>
                <Badge bg="warning" text="dark" className="px-3 py-2">
                  🌟 Solution sur mesure
                </Badge>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card className="border-0 shadow-lg rounded-4 overflow-hidden">
                <Card.Body className="p-5">
                  <Row className="align-items-center">
                    <Col md={8}>
                      <div className="d-flex align-items-center mb-3">
                        <div className="bg-success rounded-circle p-2 me-3">
                          <FaRocket className="text-white" size={24} />
                        </div>
                        <div>
                          <h3 className="h4 mb-1">Démarrez votre projet dès aujourd'hui</h3>
                          <p className="text-muted mb-0">Obtenez une consultation gratuite avec nos experts</p>
                        </div>
                      </div>
                    </Col>
                    <Col md={4} className="text-md-end">
                      <Button 
                        variant="success" 
                        size="lg" 
                        className="rounded-pill px-4 py-2 fw-semibold"
                        href="/contact-pyrrus"
                      >
                        <FaWhatsapp className="me-2" />
                        Discuter maintenant
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Coordonnées avec design moderne */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="g-4">
            {/* Téléphone */}
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm rounded-4 text-center p-4 hover-lift">
                <div className="icon-wrapper mb-4">
                  <div className="bg-success bg-opacity-10 rounded-circle p-3 d-inline-flex">
                    <FaPhone size={28} className="text-success" />
                  </div>
                </div>
                <h3 className="h5 fw-bold mb-3">Appelez-nous</h3>
                <div className="contact-numbers">
                  <p className="mb-2">
                    <a href="tel:+33605625510" className="text-dark fw-semibold text-decoration-none h5">
                      +33 6 05 62 55 10
                    </a>
                  </p>
                  <p className="mb-3">
                    <a href="tel:+33685449935" className="text-dark fw-semibold text-decoration-none h5">
                      +33 6 85 44 99 35
                    </a>
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-center text-muted">
                  <FaClock className="me-2" size={14} />
                  <small>Lun - Ven: 9h - 18h</small>
                </div>
              </Card>
            </Col>

            {/* Email */}
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm rounded-4 text-center p-4 hover-lift">
                <div className="icon-wrapper mb-4">
                  <div className="bg-primary bg-opacity-10 rounded-circle p-3 d-inline-flex">
                    <FaEnvelope size={28} className="text-primary" />
                  </div>
                </div>
                <h3 className="h5 fw-bold mb-3">Envoyez-nous un email</h3>
                <p className="mb-4">
                  <a 
                    href="mailto:hello@guirette.net" 
                    className="text-dark fw-semibold text-decoration-none h6"
                  >
                    hello@guirette.net
                  </a>
                </p>
                <small className="text-muted">
                  Réponse garantie sous 24h
                </small>
              </Card>
            </Col>

            {/* Adresse */}
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm rounded-4 text-center p-4 hover-lift">
                <div className="icon-wrapper mb-4">
                  <div className="bg-warning bg-opacity-10 rounded-circle p-3 d-inline-flex">
                    <FaMapMarkerAlt size={28} className="text-warning" />
                  </div>
                </div>
                <h3 className="h5 fw-bold mb-3">Rencontrons-nous</h3>
                <address className="mb-0">
                  <strong>GUIRETTE SAS</strong><br />
                  34 Boulevard NEUF<br />
                  13013 Marseille, France
                </address>
                <small className="text-muted mt-2">
                  Sur rendez-vous
                </small>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Réseaux sociaux améliorés */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h2 className="h3 fw-bold mb-1">Restons connectés</h2>
              <p className="text-muted mb-4">
                Suivez notre actualité et découvrez nos derniers projets
              </p>
              
              <div className="social-section">
                <Row className="g-3 justify-content-center">
                  <Col md={6}>
                    <Card className="border-0 bg-primary bg-opacity-10 rounded-4 p-4 hover-lift">
                      <Card.Body>
                        <FaFacebook size={32} className="text-primary mb-3" />
                        <h4 className="h6 fw-bold mb-2">Facebook</h4>
                        <p className="text-muted small mb-3">
                          Actualités et conseils
                        </p>
                        <Button 
                          variant="outline-primary" 
                          size="sm"
                          href="https://www.facebook.com/share/16TEncfEqF/"
                          target="_blank"
                        >
                          Nous suivre
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                  <Col md={6}>
                    <Card className="border-0 bg-info bg-opacity-10 rounded-4 p-4 hover-lift">
                      <Card.Body>
                        <FaLinkedin size={32} className="text-info mb-3" />
                        <h4 className="h6 fw-bold mb-2">LinkedIn</h4>
                        <p className="text-muted small mb-3">
                          Réseau professionnel
                        </p>
                        <Button 
                          variant="outline-info" 
                          size="sm"
                          href="https://www.linkedin.com/company/guirette/"
                          target="_blank"
                        >
                          Nous suivre
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section équipe */}
      <section className="py-5 bg-dark text-white">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h2 className="h3 fw-bold mb-3">Une équipe passionnée à votre service</h2>
              <p className="lead mb-4 opacity-75">
                Chez GUIRETTE, nous croyons en la puissance de la collaboration. 
                Chaque projet est unique et mérite une attention particulière.
              </p>
              <Button 
                variant="outline-light" 
                size="lg"
                className="rounded-pill px-4"
                href="/about"
              >
                Découvrir notre équipe
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Contact;